module.exports = __webpack_public_path__ + "fonts/NanumGothic-Regular.3cbe9257.ttf";